import { handleAction, handleActions } from "redux-actions";

import {
    positionMetaRemove,
    positionsAddPosition,
    positionsHighlightPosition,
    positionsSetData,
    positionsSetSuggestions,
} from "./actions";

const suggestions = handleAction(
    positionsSetSuggestions,
    (state, { payload: { positions, group } }) => ({ positions, group }),
    {
        positions: [],
        group: "",
    },
);

const positions = handleActions(
    {
        [positionsAddPosition]: (state, { payload }) => {
            if (state.find((p) => p.id === payload.id)) {
                return state.map((p) => {
                    if (p.id === payload.id) {
                        return payload;
                    }

                    return p;
                });
            }

            return [...state, payload];
        },
        [positionsHighlightPosition]: (state, { payload: { id, highlight } }) =>
            state.map((position) => {
                if (position.id === id) {
                    return {
                        ...position,
                        highlight,
                    };
                }

                return position;
            }),
        [positionsSetData]: (state, { payload }) => payload,
    },
    [],
);

const positionMetas = handleActions(
    {
        [positionMetaRemove]: (state, { payload }) =>
            state.filter((p) => p.id !== payload.positionMetaID),
    },
    [],
);

// Intentionally not using combineReducers. This should be imported into
// another reducer and combined there.
export default {
    positions,
    positionMetas,
    suggestions,
};
